import Vue from "vue";

import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import loadingModalComponent from "@/components/child/loadingmodal/loadingmodal.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import FranquiaModel, { FranquiaListParameters } from "@/models/franquiaModel";
import franquiaService from "@/services/franquiaService";
import "../crud.scss";

@Component({
    components: {
        loadingModalComponent,
        shortcutComponent,
        dataTooltipComponent,
        gridComponent,
    },
})
export default class ReplicarSelecaoFranquiaComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;
    private showFranquias = false;

    gridFilterKey = "";
    gridSortKey = "nomeFantasia";
    gridSortOrder = "asc";
    gridData: Array<FranquiaModel> = [];
    gridSelectedValues: Array<FranquiaModel> = [];
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nomeFantasia", "Nome Fantasia", GridColumnType.String),
            new GridColumn("cnpj", "Cnpj", GridColumnType.String),
        ];
    }

    pageIndex = 1;
    pageSize = 999999;
    total = 0;

    constructor() {
        super();
    }

    private onConfirm() {
        if (this.gridSelectedValues.length > 0) {
            this.$emit(
                "replicar",
                this.gridSelectedValues.map(p => p.id),
            );
            this.shortcutComponent.hide();
        } else this.shortcutComponent.hide();
    }

    public openFranquias() {
        if (!this.showFranquias) this.load();

        this.showFranquias = true;
        this.shortcutComponent.show();
    }

    private async load() {
        const customParameters: FranquiaListParameters = { ignoreCurrentFranquia: true };
        const franquias = await franquiaService.list(
            this.gridFilterKey,
            this.gridSortKey,
            this.gridSortKey,
            this.pageIndex,
            this.pageSize,
            customParameters,
        );
        this.gridData = franquias.list;
        this.total = franquias.total;
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.load();
    }

    private onChangeSort(sortKey: string, sortOrder: string) {
        this.gridSortKey = sortKey;
        this.gridSortOrder = sortOrder;
        this.load();
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.load();
    }

    private onSelectedValuesChanged(values: Array<FranquiaModel>) {
        this.gridSelectedValues = values;
    }

    private mounted() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = this.$t("__.ts.selecFranq").toString();
    }
}
